import CloseIcon from "@mui/icons-material/Close";
import HelpIcon from "@mui/icons-material/Help";
import SendIcon from "@mui/icons-material/Send";
import {
  Avatar,
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import Divider from "@mui/material/Divider";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BIBlue,
  BIGreen,
  BIGrey,
  BILightGreen,
  BILightGrey,
  BILightRed,
  BILightYellow,
  BIRed,
  BIYellow
} from "../../assets/helpers";
import Loader from "../../common/Loader";
import PictureViewer from "../../common/PictureViewer";
import {
  FETCH_CLIENT_SUPPORT_2,
  FETCH_CLIENT_SUPPORT_HISTORY_V2,
  SAVE_CLIENT_SUPPORT_HISTORY
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import { setShowalert } from "../../redux/actions/actions";

function ViewClientSupport({ open, handleClose, supportId, setLoadNew, custom }) {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const { selectedClientData } = useSelector((state) => state?.main);
  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState(true);
  const [supportData, setSupportData] = useState([]);
  const [supportHistoryData, setSupportHistoryData] = useState([]);
  const [showHelpTip, setShowHelpTip] = useState(false);
  const [commentDescription, setCommentDescription] = useState("");
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [pictureViewIndex, setPictureViewIndex] = useState(0);

  const [messageSend, setMessagesend] = useState(false);
  
  const commentsEndRef = useRef(null);

  const scrollToBottom = () => {
    commentsEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const LANGUAGE = ClientEnglishFallback.ViewClientSupport(
    multiLanguageData?.ViewClientSupport || {}
  );
  const {
    TEXT_CLOSE_THIS_SUPPORT_REQUEST_TO_LET,
    TEXT_KNOW_THAT_YOUR_ISSUE_HAS_BEEN_RESOLVED,
    TEXT_IF_YOU_REQUIRE_FURTHER_SUPPORT_YOU_CAN_RE_OPEN_THIS_REQUEST,
    BUTTON_OK,
    TEXT_URGENCY,
    TEXT_EXPECTED_COMPLETION_DATE,
    TEXT_STATUS,
    TEXT_WRITE_A_COMMENT_PLACE_HOLDER,
    TEXT_NO_DATA_FROM_THE_API,
    TEXT_RE_OPEN_REQUEST,
    TEXT_CLOSE_REQUEST,
    TEXT_ME
  } = LANGUAGE;

  useEffect(() => {
    getInitialData();
  }, []);

  const getInitialData = async () => {
    setIsLoading(true);
    await getSingleSupportData();
    await getSingleSupportChatData();
    setIsLoading(false);
  };

  const getSingleSupportData = async () => {
    const obj = {
      PageNr: 1,
      NrOfRecPerPage: 20,
      FullSearch: "",
      UserId: loginData?.userInformation?.UserId,
      IncludeRecordNr: false,
      FetchAllowedRecordsOnly: true,
      SearchList: [
        {
          Id: custom ? custom : supportId
        }
      ],
      SortList: [
        {
          FieldName: "Id",
          Direction: "DESC"
        }
      ]
    };

    try {
      const SupportResponse = await Postrequestcall(
        FETCH_CLIENT_SUPPORT_2,
        obj,
        loginData?.accessToken
      );

      if (SupportResponse.status === 200) {
        if (SupportResponse?.data?.data.length !== 0) {
          setSupportData(SupportResponse?.data?.data[0]);
        } else {
          setSupportData([]);
        }
      } else {
        setSupportData([]);
      }
    } catch (error) {
      setSupportData([]);
      console.log("getSingleSupportData-> Error Getting Client Support Data: ", error);
    }
    setIsLoading(false);
  };

  const getSingleSupportChatData = async () => {
    const obj = {
      PageNr: 1,
      NrOfRecPerPage: 20,
      FullSearch: "",
      UserId: loginData?.userInformation?.UserId,
      IncludeRecordNr: true,
      FetchAllowedRecordsOnly: true,
      SearchList: [
        {
          supportId: custom ? custom : supportId
        }
      ],
      // SortList: [
      //   {
      //     FieldName: "Id",
      //     Direction: "ASC"
      //   }
      // ]
    };
    try {
      const SupportHistoryResponse = await Postrequestcall(
        FETCH_CLIENT_SUPPORT_HISTORY_V2,
        obj,
        loginData?.accessToken
      );
      if (SupportHistoryResponse.status === 200) {
        if (SupportHistoryResponse?.data?.data?.length > 0) {
          setSupportHistoryData(SupportHistoryResponse?.data?.data);
        } else {
          setSupportHistoryData([]);
        }
      } else {
        setSupportHistoryData([]);
      }
    } catch (error) {
      setSupportHistoryData([]);
      console.log("getSingleSupportChatData-> Error Getting Client Support Chat Data: ", error);
    }
    setIsLoading(false);
  };

  const getBgColor = (status) => {
    switch (status) {
      case "Open":
        return BILightGrey;
      case "Closed":
        return BILightGreen;
      case "Completed":
        return BILightYellow;
      default:
        return BILightGrey;
    }
  };

  const getColor = (status) => {
    switch (status) {
      case "Open":
        return BIGrey;
      case "Closed":
        return BIGreen;
      case "Completed":
        return BIYellow;
      default:
        return BIGrey;
    }
  };

  const handleToggleShowHelpTip = () => {
    let alertObj = {
      showAlert: !showHelpTip,
      title: `${TEXT_CLOSE_THIS_SUPPORT_REQUEST_TO_LET} ${selectedClientData?.OrganizationName} 
                ${TEXT_KNOW_THAT_YOUR_ISSUE_HAS_BEEN_RESOLVED}`,
      text: TEXT_IF_YOU_REQUIRE_FURTHER_SUPPORT_YOU_CAN_RE_OPEN_THIS_REQUEST
    };
    dispatch(setShowalert(alertObj));

    setShowHelpTip(!showHelpTip);
  };

  const handleSendClientMessage = async (status) => {
    setMessagesend(true);
    let obj = {};
    if (status) {
      obj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            SupportId: supportData.id,
            Status: status,
            StatusChangedBy: loginData?.userInformation?.UserId,
            StatusChangedDate: dayjs().format("YYYY-MM-DDTHH:mm:ss.SSS"),
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
    } else {
      obj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            SupportId: supportData.id,
            Status: supportData.status,
            StatusChangedBy: loginData?.userInformation?.UserId,
            StatusChangedDate: dayjs().format("YYYY-MM-DDTHH:mm:ss.SSS"),
            Comment: commentDescription,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
    }
    const isMessageSent = await Postrequestcall(
      SAVE_CLIENT_SUPPORT_HISTORY,
      obj,
      loginData?.accessToken
    );
    setCommentDescription("");
    if (isMessageSent) {
      await getSingleSupportChatData();
      setLoadNew(true);
      // Scroll to the latest comment after a short delay to ensure DOM update
      setTimeout(() => scrollToBottom(), 100);
    }
    setMessagesend(false);
    if (status) {
      setIsLoading(true);
      await getSingleSupportData();
      await getSingleSupportChatData();
      setIsLoading(false);
    }
  };

  const showData = (history, index) => {
    return (
      supportData.status === "Closed" &&
      history.status === "Completed" &&
      index + 1 < supportHistoryData?.length
    );
  };

  const handlePreviewImage = (index) => {
    setPictureViewIndex(index);
    setPictureViewerOpen(true);
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <>
          {isLoading ? (
            <Loader fullScreen />
          ) : (
            <>
              {supportData?.length !== 0 ? (
                <Box className="client-modal-responsive">
                  <Grid className="view-header" container spacing={1}>
                    <Grid size={12}>
                      <IconButton
                        className="view-close"
                        sx={{
                          color:
                            selectedClientData?.AccentColor !== undefined &&
                              selectedClientData?.AccentColor
                              ? selectedClientData?.AccentColor
                              : BILightGrey
                        }}
                        onClick={handleClose}>
                        <CloseIcon />
                      </IconButton>
                    </Grid>
                    <Grid size={12}>
                      <Box
                        sx={{ alignItems: "center",  justifyContent: "space-between",  display: "flex" }}
                        
                        
                        width="100%">
                        <Box sx={{ gap: 1,  alignItems: "center",  display: "flex"  }}  >
                          <Avatar src={supportData.userProfilePicture} />
                          <Typography variant="body1">
                            {supportData.userName} {TEXT_ME}
                          </Typography>
                        </Box>
                        <Typography variant="body1" gutterBottom sx={{ color: BIGrey }}>
                          {dayjs(supportData.dateSubmitted).format("MMMM DD, YYYY")}
                        </Typography>
                      </Box>
                    </Grid>

                    {supportData.supportCategoryName && (
                      <Grid size={6}>
                        <Chip label={supportData.supportCategoryName} />
                      </Grid>
                    )}
                  </Grid>

                  <Grid container size={{ xs: 12 }} sx={{ marginTop: 1 }} spacing={1}>
                    <Grid size={6}>
                      <Typography variant="body1" sx={{ color: BIGrey }}>
                        {TEXT_URGENCY}
                      </Typography>
                      <Typography variant="body1">
                        {supportData.urgencyId} {" - "} {supportData.urgencyName}
                      </Typography>
                    </Grid>
                    <Grid size={6}>
                      {supportData?.ecDate !== "" && supportData?.ecDate !== null && (
                        <>
                          <Typography variant="body1" sx={{ color: BIGrey }}>
                            {TEXT_EXPECTED_COMPLETION_DATE}
                          </Typography>
                          <Typography variant="body1">
                            {dayjs(supportData.ecDate).format("MMMM DD, YYYY")}
                          </Typography>
                        </>
                      )}
                    </Grid>
                    <Grid sx={{ gap: 1,  display: "flex", scrollbarWidth: "none"  }} size={12}  overflow={"scroll"}>
                      {supportData.pictureList?.length !== 0 &&
                        supportData.pictureList?.map((url, index) => (
                          <img
                            key={index}
                            src={url.fileUrl}
                            alt={index}
                            height={100}
                            width={100}
                            style={{ cursor: "pointer", borderRadius: "10px" }}
                            onClick={() =>
                              handlePreviewImage(index, supportData.pictureList[index].fileUrl)
                            }
                          />
                        ))}
                    </Grid>
                    <Grid size={12}>
                      <Typography variant="body1" sx={{ color: BIGrey }}>
                        {TEXT_STATUS}
                      </Typography>
                    </Grid>
                    <Grid size={12}>
                      <Chip
                        label={supportData.status}
                        style={{
                          backgroundColor: getBgColor(supportData.status),
                          color: getColor(supportData.status)
                        }}
                      />
                    </Grid>
                    <Grid size={12}>
                      <Divider />
                    </Grid>

                    <Grid
                      size={12}
                      height={"150px"}
                      overflow={"scroll"}
                      sx={{ scrollbarWidth: "none" }}>
                      <Grid size={12}>
                        <Typography
                          variant="body1"
                          sx={{ color: BIGrey }}
                          textAlign={"center"}
                          gutterBottom>
                          {"Opened "}
                          {dayjs(supportData.dateSubmitted).format("MMMM DD, YYYY, hh:mm A")}
                        </Typography>
                      </Grid>
                      <Grid size={12}>
                        <Typography variant="body1" gutterBottom>
                          {supportData.description}
                        </Typography>
                      </Grid>
                      <Stack
                        sx={{
                          maxHeight: "300px",
                          overflowY: "auto"
                        }}>
                        {supportHistoryData?.map((history, index) => (
                          <div key={index}>
                            <Grid size={12} key={history.id}>
                              {history.comment !== "" && (
                                <Box
                                  sx={{ alignItems: "center",  justifyContent: "space-between",  display: "flex" }}
                                  
                                  
                                  width="100%">
                                  <Box sx={{ gap: 1,  alignItems: "center",  display: "flex"  }}  >
                                    <Avatar src={history.userProfilePicture} />
                                    <Typography variant="body1" gutterBottom>
                                      {history.statusChangedByUser}
                                    </Typography>
                                  </Box>
                                  <Typography variant="body1" gutterBottom sx={{ color: BIGrey }}>
                                    {dayjs(history.statusChangedDate).format("MMMM DD, YYYY")}
                                  </Typography>
                                </Box>
                              )}
                            </Grid>
                            <Grid size={12}>
                              <Typography variant="body1" gutterBottom>
                                {history.comment}
                              </Typography>
                            </Grid>
                            <Grid size={12}>
                              <Typography
                                variant="body1"
                                sx={{ color: BIGrey }}
                                textAlign={"center"}
                                gutterBottom
                                visibility={showData(history, index) ? "hidden" : ""}>
                                {
                                  // Check if it's the first time the status is "Open"
                                  index === 0 && history?.status === "Open"
                                    ? ""
                                    : // Check if the previous status was "Closed" or "Completed" and the current status is "Open"
                                    (supportHistoryData[index - 1]?.status === "Closed" ||
                                      supportHistoryData[index - 1]?.status === "Completed") &&
                                      history?.status === "Open"
                                      ? "Re opened "
                                      : supportHistoryData[index - 1]?.status === "Open" &&
                                        history?.status === "Open"
                                        ? ""
                                        : // Otherwise, show the status only if it's different from the previous status
                                        history?.status !== supportHistoryData[index - 1]?.status
                                          ? history?.status
                                          : ""
                                }

                                {
                                  // Show the date if the status is "Re opened"
                                  (history?.status === "Completed" &&
                                    supportHistoryData[index - 1]?.status !== "Completed") ||
                                    (history?.status === "Closed" &&
                                      supportHistoryData[index - 1]?.status !== "Closed") ||
                                    (history?.status === "Completed" &&
                                      supportHistoryData[index - 1]?.status === "Completed" &&
                                      index === supportHistoryData.length - 1)
                                    ? dayjs(history.statusChangedDate).format(
                                      " MMMM DD, YYYY, hh:mm A"
                                    )
                                    : history?.status === "Open" &&
                                      (supportHistoryData[index - 1]?.status === "Closed" ||
                                        supportHistoryData[index - 1]?.status === "Completed")
                                      ? dayjs(history.statusChangedDate).format(
                                        " MMMM DD, YYYY, hh:mm A"
                                      )
                                      : ""
                                }
                              </Typography>
                            </Grid>
                          </div>
                        ))}
                        <div ref={commentsEndRef} />
                      </Stack>
                    </Grid>
                  </Grid>

                  {supportData.status === "Completed" ? (
                    <Box sx={{ gap: 1,  justifyContent: "space-between",  display: "flex"  }}  >
                      <Button
                        fullWidth
                        size="small"
                        variant="contained"
                        style={{
                          backgroundColor: BILightRed,
                          color: BIRed
                        }}
                        className="support-button"
                        onClick={() => handleSendClientMessage("Open")}>
                        {TEXT_RE_OPEN_REQUEST}
                      </Button>
                      <Button
                        fullWidth
                        size="small"
                        variant="contained"
                        style={{
                          backgroundColor: BILightGreen,
                          color: BIGreen
                        }}
                        className="support-button"
                        onClick={() => handleSendClientMessage("Closed")}>
                        {TEXT_CLOSE_REQUEST}
                      </Button>
                      <IconButton onClick={handleToggleShowHelpTip}>
                        <HelpIcon style={{ color: BIRed }} />
                      </IconButton>
                    </Box>
                  ) : supportData.status === "Open" ? (
                    <Box
                      sx={{ alignItems: "center",  justifyContent: "space-between",  display: "flex" }}
                      
                      
                      gap={1}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        onChange={(e) => {
                          let inputValue = e.target.value;
                          inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                          setCommentDescription(inputValue);
                        }}
                        value={commentDescription}
                        placeholder={TEXT_WRITE_A_COMMENT_PLACE_HOLDER}
                        style={{
                          backgroundColor: "lightgray",
                          marginTop: "10px",
                          borderRadius: "10px"
                        }}
                        size="small"
                        sx={{
                          "& fieldset": { border: "none" }
                        }}
                        disabled={messageSend ? true : false}
                      />
                      <IconButton
                        disabled={commentDescription == "" || messageSend}
                        onClick={() => handleSendClientMessage()}>
                        {messageSend ? (
                          <CircularProgress
                            size={24}
                            sx={{ color: selectedClientData?.AccentColor }}
                          />
                        ) : (
                          <SendIcon
                            style={{
                              height: "25px",
                              width: "25px",
                              color:
                                commentDescription == "" ? "grey" : selectedClientData?.AccentColor
                            }}
                          />
                        )}
                      </IconButton>
                    </Box>
                  ) : null}
                </Box>
              ) : (
                <Box className="client-modal-responsive">{TEXT_NO_DATA_FROM_THE_API}</Box>
              )}
            </>
          )}
        </>
      </Modal>
      {pictureViewerOpen && (
        <PictureViewer
          isOpen={pictureViewerOpen}
          onClose={() => setPictureViewerOpen(false)}
          pictures={supportData?.pictureList?.map((pic) => ({
            src: pic.fileUrl,
            alt: ""
          }))}
          viewerIndex={pictureViewIndex}
        />
      )}
    </>
  );
}

export default ViewClientSupport;

